/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The kinds of people in an organization.
 */
export enum PersonKind {
  STUDENT = "student",
  PARENT = "parent",
  TUTOR = "tutor",
}
